import {Observable} from 'rxjs';

import {combineEpics} from 'web-app/util/redux-observable';

import * as Api from './api';
import Actions from './actions';
import ActionTypes from './action-types';

const createArea = action$ =>
    action$.ofType(ActionTypes.AREA_CREATE).mergeMap(({payload}) => {
        const organizationId = payload.area.organizationId;
        const areaTitle = payload.area.areaTitle;

        return Api.createArea(organizationId, areaTitle)
            .map(newArea => Actions.createSuccess(newArea))
            .catch(e => Observable.of(Actions.createFailed(e)));
    });

const addAreaToInstitutionArea = action$ =>
    action$.ofType(ActionTypes.AREA_ADD_INSTITUTION).mergeMap(({payload}) =>
        Api.addInstitutionToArea(payload.areaId, payload.institutionId)
            .map(updatedArea => Actions.addInstitutionSuccess(updatedArea))
            .catch(e => Observable.of(Actions.addInstitutionFailed(e))),
    );

const removeAreaFromInstitutionArea = action$ =>
    action$.ofType(ActionTypes.AREA_REMOVE_INSTITUTION).mergeMap(({payload}) =>
        Api.removeInstitutionFromArea(payload.areaId, payload.institutionId)
            .map(updatedArea => Actions.removeInstitutionSuccess(updatedArea))
            .catch(e => Observable.of(Actions.removeInstitutionFailed(e))),
    );
export default combineEpics(createArea, addAreaToInstitutionArea, removeAreaFromInstitutionArea);
